// @needs-native-review — best-effort translation
import type { Translations } from '../types';

export const gu: Translations = {
  'meta.gameTitle': 'Luminary',

  'howto.title': 'કેવી રીતે રમવું',
  'howto.pieces.heading': 'ટુકડા',
  'howto.pieces.source': 'સ્રોત',
  'howto.pieces.mirror': 'અરીસો',
  'howto.pieces.switch': 'સ્વિચ',
  'howto.pieces.exit': 'નિર્ગમ',
  'howto.pieces.wall': 'દિવાલ',
  'howto.controls.heading': 'નિયંત્રણો',
  'howto.controls.clickSlot.line1': 'જગ્યા પર ક્લિક કર',
  'howto.controls.clickSlot.line2': 'અરીસો મૂક',
  'howto.controls.dragMirror.line1': 'અરીસો ખેંચ',
  'howto.controls.dragMirror.line2': 'ફેરવ',
  'howto.controls.rightClick.line1': 'જમણી-ક્લિક',
  'howto.controls.rightClick.line2': 'અરીસો કાઢ',
  'howto.controls.hint': 'માઉસ વ્હીલ: 1° નું સૂક્ષ્મ ફેરવવું.   અરીસા પર ટેપ: 15° નું ફેરવવું.',
  'howto.objective.line1': 'દરેક સ્વિચને પ્રકાશિત કર — નિર્ગમનું તાળું ખુલી જાય છે.',
  'howto.objective.line2': 'પછી નિર્ગમ પર ક્લિક કર. શક્ય હોય તેટલા ઓછા અરીસાથી ઉકેલ.',

  'howtoColor.title': 'રંગ અને પ્રિઝમ',
  'howtoColor.pieces.heading': 'નવા ટુકડા',
  'howtoColor.pieces.prism': 'પ્રિઝમ',
  'howtoColor.pieces.redSwitch': 'લાલ સ્વિચ',
  'howtoColor.pieces.yellowSwitch': 'પીળો સ્વિચ',
  'howtoColor.pieces.whiteSwitch': 'સફેદ સ્વિચ',
  'howtoColor.how.heading': 'એ કેવી રીતે કામ કરે છે',
  'howtoColor.how.line1': 'સફેદ કિરણ લાલ, લીલો અને વાદળી પ્રકાશ એકસાથે વહન કરે છે.',
  'howtoColor.how.line2': 'પ્રિઝમ સફેદ પ્રકાશને તેની ત્રણ બાજુએ ત્રણ રંગીન કિરણોમાં વિભાજે છે.',
  'howtoColor.how.line3': 'મૂકેલ પ્રિઝમ પર ક્લિક કરી તેનો ઇનપુટ-મુખ ફેરવ.',
  'howtoColor.switches.line1': 'સ્વિચ રંગીન ટપકાં બતાવે છે — એ જ રંગ એને જોઈએ છે.',
  'howtoColor.switches.line2': 'પીળા સ્વિચ (લાલ + લીલા ટપકાં)ને બંને રંગ સાથે જોઈએ.',
  'howtoColor.switches.line3': 'સફેદ સ્વિચ (ત્રણેય રંગ)ને લાલ, લીલો અને વાદળી સાથે જોઈએ.',

  'options.hints.label': 'કોયડામાં સંકેત-ખૂણા બતાવ',
  'options.hints.help': 'દરેક પરાવર્તન વખતે આવતા અને પરાવર્તિત કિરણ વચ્ચેનો ખૂણો બતાવે છે.',

  'level.01-intro.title': 'નમસ્તે પ્રકાશ',
  'level.02-two-mirrors.title': 'બે વળાંક',
  'level.03-corner.title': 'રસ્તામાં દિવાલ',
  'level.04-two-targets.title': 'બે લક્ષ્ય',
  'level.05-tight.title': 'સંકડું',
  'level.06-hello-color.title': 'નમસ્તે રંગ',
  'level.07-pick-a-side.title': 'એક બાજુ પસંદ કર',
  'level.08-yellow.title': 'પીળો',
  'level.09-magenta.title': 'મેજેન્ટા',
  'level.10-spectrum.title': 'વર્ણપટ',

  // PuzzleScene
  'puzzle.itemCounter': '{used}/{optimal}',
  'puzzle.hint.angleType.right': 'કાટકોણ',
  'puzzle.hint.angleType.acute': 'લઘુકોણ',
  'puzzle.hint.angleType.obtuse': 'ગુરુકોણ',
  'puzzle.hint.label': '{angle}°\n{type}',
};
